/* @flow weak */

import PropTypes from 'prop-types';
import * as React from 'react';
import { findDOMNode } from 'react-dom';
import { isFeatureEnabled } from 'common/features';

import Pagination from 'common/components/Pagination';
import Render from 'common/components/Render';

import VenuePreview from 'search/components/VenuePreview';
import SearchActionCreators from 'search/actions/SearchActionCreators';

import $ from 'jquery';

import SearchHits from './searchResults/SearchHits';
import SearchSortSelect from './searchResults/SearchSortSelect';
import SlushBanner from './searchResults/SlushBanner';
import SearchInstructions from './searchResults/SearchInstructions';
import LocalSearchLinks from './searchResults/LocalSearchLinks';
import SearchResultFooter from './searchResults/SearchResultFooter';

import type {
  VenueResult,
  ResultsMeta,
  Params as SearchParams
} from 'search/types';

export type Props = {|
  params: SearchParams,
  results: {
    meta: ResultsMeta,
    venues: Array<VenueResult>
  },
  highlightCapacitySitting?: boolean,
  openInNewTab?: boolean,
  activeResultId?: number,
  isLoading?: boolean,
  features: {
    edit_relevance?: boolean
  },
  staticPagesEnabled: boolean,
  eventConsultationAvailable: boolean,
  localSearchLinksEnabled: boolean
|};

export class SearchResultsUI extends React.Component<Props> {
  static propTypes = {
    results: PropTypes.shape({
      meta: PropTypes.object.isRequired,
      venues: PropTypes.array.isRequired
    }).isRequired,
    highlightCapacitySitting: PropTypes.bool,
    openInNewTab: PropTypes.bool,
    activeResultId: PropTypes.number,
    isLoading: PropTypes.bool,
    features: PropTypes.shape({
      edit_relevance: PropTypes.bool
    }).isRequired
  };

  render() {
    const {
      highlightCapacitySitting,
      openInNewTab,
      eventConsultationAvailable,
      staticPagesEnabled,
      localSearchLinksEnabled
    } = this.props;
    const meta = this.props.results.meta;
    const resultsFound = !!meta.total;
    const noMorePages =
      !meta.total_pages || meta.current_page === meta.total_pages;

    const venuePreviewElements = this.props.results.venues.map(venue => {
      const isActive = this.props.activeResultId === venue.id;
      return (
        <VenuePreview
          venue={venue}
          highlightCapacitySitting={highlightCapacitySitting}
          openInNewTab={openInNewTab}
          isActive={isActive}
          key={venue.id}
          features={this.props.features}
        />
      );
    });

    return (
      <div className="m-search-results b-overlay-container">
        <div className="m-search-results-sorting">
          <SearchHits
            offsetStart={meta.offset_start}
            offsetEnd={meta.offset_end}
            total={meta.total}
          />
          <SearchSortSelect
            value={this.props.params.sort}
            onValue={this._onSortChange}
          />
        </div>
        {isFeatureEnabled('slush_banner_in_search') && <SlushBanner />}
        <ul className="b-search-result-list">{venuePreviewElements}</ul>
        <Pagination
          currentPage={meta.current_page}
          totalPages={meta.total_pages}
          firstPageURL={meta.first_page_url}
          lastPageURL={meta.last_page_url}
          nextPageURL={meta.next_page_url}
          previousPageURL={meta.previous_page_url}
          onPageChange={this._onPageChange}
        />
        <Render when={noMorePages}>
          {localSearchLinksEnabled ? (
            <LocalSearchLinks />
          ) : (
            <SearchInstructions
              resultsFound={resultsFound}
              eventConsultationAvailable={eventConsultationAvailable}
            />
          )}
        </Render>
        <SearchResultFooter staticPagesEnabled={staticPagesEnabled} />
        <div className="m-search-results-fade" />
        {this.props.isLoading && (
          <div className="b-overlay b-overlay--full b-overlay--light" />
        )}
      </div>
    );
  }

  _onSortChange = (sorting: ?string) => {
    SearchActionCreators.changeSorting(sorting);
  };

  _onPageChange = nextPage => {
    SearchActionCreators.changePage(nextPage);
    this._scrollToResults();
  };

  _scrollToResults = () => {
    const offsetY = $(findDOMNode(this)).offset().top - $('.m-navbar').height();
    window.scrollTo(0, offsetY);
  };
}

type ContainerState = {|
  staticPagesEnabled: boolean,
  eventConsultationAvailable: boolean,
  localSearchLinksEnabled: boolean
|};

class SearchResultsContainer extends React.Component<
  // FIXME: This "Props" type assumes that SearchResultsContainer would also
  // need the props that are in `ContainerState`, which is incorrect
  Props,
  ContainerState
> {
  state = {
    staticPagesEnabled: isFeatureEnabled('static_pages'),
    eventConsultationAvailable: isFeatureEnabled(
      'advertise_event_consultation_in_search_results'
    ),
    localSearchLinksEnabled: isFeatureEnabled('local_search_links')
  };

  render() {
    return <SearchResultsUI {...this.props} {...this.state} />;
  }
}

export default SearchResultsContainer;
